import settings from '../settings';

const roundingDimensionMethod = (num) => {
  if (num === null) return 0;
  var re = new RegExp('^-?\\d+(?:.\\d{0,' + (settings.dimensionVolumeDecimals || -1) + '})?');
  return +num.toString().match(re);
};

export default roundingDimensionMethod;
